import http from './http'

export interface FloatCoupon {
  code: string
  type: string
  value: number
}

/**
 * قائمة الكوبونات المعروضة في المربع العائم (للمستخدم المسجل).
 * GET /api/coupons/float
 */
export async function getFloatCoupons(): Promise<FloatCoupon[]> {
  const res = await http.get<{ data: FloatCoupon[] }>('/api/coupons/float')
  return res.data?.data ?? []
}
